import { atom } from 'jotai'
import { sessionAtom } from 'user-auth/helpers/sessionAtom'

type SignInView = 'default' | 'emailPassword'
type SignUpView =
  | 'default'
  | 'createAccount'
  | 'emailPassword'
  | 'emailPasswordConfirm'

export const atoms = {
  form: {
    signIn: atom<SignInView>('default'),
    signUp: atom<SignUpView>('default')
  },
  // to manage passwordless form
  otp: {
    email: sessionAtom<string>('auth:email', ''),
    firstName: sessionAtom<string>('auth:firstName', ''),
    lastName: sessionAtom<string>('auth:lastName', '')
  },
  // to manage email-password form
  credential: {
    email: atom(''),
    firstName: atom(''),
    lastName: atom(''),
    password: atom('')
  }
}
